export default "__VITE_ASSET__CZtgRK2X__"